import React from 'react';
import { COLORS_CONSTANTS } from '../../constants/Colors';
import { FONTS } from '../../constants/Fonts';

/**
 * Reusable Button Component — pastel glass theme defaults
 */
const Button = ({
  text,
  onClick,
  backgroundColor = COLORS_CONSTANTS.ACTION_BUTTON_BACKGROUND_1,
  color = COLORS_CONSTANTS.ACTION_BUTTON_TEXT_1,
  width = 'auto',
  height = 'auto',
  fontSize = '16px',
  fontStyle = 'normal',
  fontWeight = '600',
  fontFamily = FONTS.MONTSERRAT_BOLD,
  fontOpacity = 1,
  letterSpacing = 0,
  borderRadius = COLORS_CONSTANTS.BUTTON_RADIUS,
  padding = '12px 30px',
  margin = '0',
  border = `2px solid ${COLORS_CONSTANTS.ACTION_BUTTON_BORDER_COLOR_1}`,
  boxShadow = COLORS_CONSTANTS.BUTTON_SHADOW,
  disabled = false,
  className = '',
  style = {},
  ...props
}) => {
  const buttonStyle = {
    background: backgroundColor,
    backgroundColor,
    color,
    width,
    height,
    fontSize,
    fontStyle,
    fontWeight,
    fontFamily,
    opacity: disabled ? 0.6 : fontOpacity,
    letterSpacing,
    borderRadius,
    padding,
    margin,
    border,
    boxShadow: disabled ? 'none' : boxShadow,
    backdropFilter: `blur(${COLORS_CONSTANTS.GLASS_BLUR})`,
    WebkitBackdropFilter: `blur(${COLORS_CONSTANTS.GLASS_BLUR})`,
    cursor: disabled ? 'not-allowed' : 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'rotate(-0deg)',
    transition: 'transform 0.3s ease',
    boxSizing: 'border-box',
    ...style
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={buttonStyle}
      onMouseEnter={(e) => {
        if (!disabled) e.currentTarget.style.transform = 'rotate(-0deg) scale(1.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'rotate(-0deg) scale(1)';
      }}
      {...props}
    >
      {text}
    </button>
  );
};

export default Button;
